import React from "react";
import { FormProvider } from "react-hook-form";
import { Button, Dialog, Form } from "@sscs/ui";
import { GROUP_ROLE_DETAILS } from "Constants";
import { GroupRole } from "Types";
import { useEditGroupRoleForm } from "./useEditGroupRoleForm";

type EditGroupRoleProps = {
  user: string;
  memberId: string;
  groupId: string;
  currentRole: GroupRole;
  isOpen: boolean;
  onClose: () => void;
};

const EditGroupRoleContent = ({
  user,
  memberId,
  groupId,
  currentRole,
  onClose,
}: Omit<EditGroupRoleProps, "isOpen">): React.JSX.Element => {
  const { onSubmit, errors, methods } = useEditGroupRoleForm({
    onClose,
    currentRole,
    memberId,
    groupId,
  });

  return (
    <>
      <Dialog.Header>
        <Dialog.Header.Title>
          Change group role for <span>{user}</span>
        </Dialog.Header.Title>
      </Dialog.Header>
      <FormProvider {...methods}>
        <Form.Form onSubmit={onSubmit}>
          <Dialog.Body>
            <Dialog.Section>
              <Dialog.Section.Content>
                <Form.RadioGroup
                  name="role"
                  items={Object.values(GROUP_ROLE_DETAILS)}
                  errors={errors}
                  id="select-group-role"
                />
              </Dialog.Section.Content>
            </Dialog.Section>
          </Dialog.Body>
          <Dialog.Footer>
            <Dialog.Footer.Actions>
              <Button color="secondary" onClick={onClose}>
                Cancel
              </Button>
              <Button type="submit" color="primary">
                Change role
              </Button>
            </Dialog.Footer.Actions>
          </Dialog.Footer>
        </Form.Form>
      </FormProvider>
    </>
  );
};

const EditGroupRole = ({
  isOpen,
  ...props
}: EditGroupRoleProps): React.JSX.Element => (
  <Dialog.Frame size="md" isOpen={isOpen} onClose={props.onClose}>
    <EditGroupRoleContent {...props} />
  </Dialog.Frame>
);

export default EditGroupRole;
